(() => {
  document.querySelectorAll('.sc-add-form').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (button.disabled) return;
      const status = form.closest('.sc-card').querySelector('.sc-status');
      const label = button.textContent;
      button.disabled = true;
      button.textContent = button.dataset.adding;
      status.textContent = '';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const added = await response.json();
        if (!response.ok) throw new Error(added.description || button.dataset.error);
        status.textContent = button.dataset.added;
        const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-sh-cart-count]').forEach(el => el.textContent = cart.item_count);
        }
      } catch (error) {
        status.textContent = error.message || button.dataset.error;
      } finally {
        button.disabled = false;
        button.textContent = label;
      }
    });
  });
})();
